import {
  Alert,
  Button,
  Col,
  DisplayData,
  FormattedCurrency,
  FormattedDecimal,
  Modal,
  Panel,
  Row,
  SectionTitle
} from '@elotech/components';
import React from 'react';

const ValoresItbiSection = ({ dados, isFinanciado }) => {
  const temFinanciado = isFinanciado && dados.valorFinanciadoSugerido > 0;
  const totalItbi = temFinanciado
    ? (dados.valorItbi || 0) + (dados.valorFinanciadoItbi || 0)
    : dados.valorItbi;

  return (
    <>
      <SectionTitle>Valores Sugeridos</SectionTitle>
      <div className="display-data border small mt-xs">
        <Row>
          <Col sm={12}>
            <DisplayData title="Base de Cálculo">
              {dados.baseCalculo}
            </DisplayData>
          </Col>
        </Row>
        <Row>
          <Col sm={4}>
            <DisplayData title="Valor da Avaliação">
              <FormattedCurrency value={dados.valorSugerido} />
            </DisplayData>
          </Col>
          <Col sm={4}>
            <DisplayData title="Alíquota">
              <FormattedDecimal value={dados.aliquota} />%
            </DisplayData>
          </Col>
          <Col sm={4}>
            <DisplayData title="Valor do ITBI">
              <strong>
                <FormattedCurrency value={dados.valorItbi} />
              </strong>
            </DisplayData>
          </Col>
        </Row>

        {temFinanciado && (
          <>
            <SectionTitle>Parte Financiada</SectionTitle>
            <Row>
              <Col sm={4}>
                <DisplayData title="Valor Financiado">
                  <FormattedCurrency value={dados.valorFinanciadoSugerido} />
                </DisplayData>
              </Col>
              <Col sm={4}>
                <DisplayData title="Alíquota Financiado">
                  <FormattedDecimal value={dados.aliquotaFinanciado} />%
                </DisplayData>
              </Col>
              <Col sm={4}>
                <DisplayData title="Valor ITBI Financiado">
                  <strong>
                    <FormattedCurrency value={dados.valorFinanciadoItbi} />
                  </strong>
                </DisplayData>
              </Col>
            </Row>
          </>
        )}

        {temFinanciado && (
          <Row>
            <Col sm={12}>
              <DisplayData title="Total ITBI">
                <strong>
                  <FormattedCurrency value={totalItbi} />
                </strong>
              </DisplayData>
            </Col>
          </Row>
        )}
      </div>
    </>
  );
};

const ItbiMaisFacilModal = ({
  dados,
  isFinanciado,
  textoItbiMaisFacil,
  onAccept,
  onDecline,
  onClose
}) => {
  return (
    <Modal onClose={onClose}>
      <Panel title="ITBI Mais Fácil">
        {textoItbiMaisFacil && (
          <div className="display-data border mt-xs mb-xs">
            <div
              className="typography-size-14px ql-editor"
              dangerouslySetInnerHTML={{ __html: textoItbiMaisFacil }}
            />
          </div>
        )}

        <ValoresItbiSection dados={dados} isFinanciado={isFinanciado} />

        <p className="mt-xs mb-xs">
          Deseja continuar com o fluxo do ITBI Mais Fácil utilizando o valor de
          referência?
        </p>

        <Row>
          <Col md={12} className="form-group right">
            <Button
              onClick={onDecline}
              color="neutral"
              className="inline mt-xs mb-xs"
            >
              Não
            </Button>
            <Button
              onClick={onAccept}
              color="positive"
              className="inline mt-xs mb-xs"
            >
              Sim
            </Button>
          </Col>
        </Row>
      </Panel>
    </Modal>
  );
};

export const showItbiMaisFacilSuccess = boleto => {
  const hasBoleto = boleto && boleto.url;

  return Alert.success({
    title: 'ITBI Mais Fácil - Concluído!',
    text: hasBoleto
      ? 'Sua declaração foi deferida automaticamente pelo ITBI Mais Fácil. O boleto para pagamento já está disponível.'
      : 'Sua declaração foi deferida automaticamente pelo ITBI Mais Fácil. Sua guia de pagamento será gerada em breve.'
  });
};

export const showTramitacaoAutomaticaSuccess = boleto => {
  const hasBoleto = boleto && boleto.url;

  return Alert.success({
    title: 'Tramitação Automática - Concluído!',
    text: hasBoleto
      ? 'Sua declaração foi processada automaticamente. O boleto para pagamento já está disponível.'
      : 'Sua declaração foi processada automaticamente. Sua guia de pagamento será gerada em breve.'
  });
};

export default ItbiMaisFacilModal;
